import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material';
import { stringify } from 'querystring';

@Component({
  selector: 'app-select-couleur',
  templateUrl: './select-couleur.component.html',
  styleUrls: ['./select-couleur.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelectCouleurComponent {

    @Input() id: string;
    @Input() label: string;
    @Input() value: string;
    @Input() canSelectMultipleValues: boolean;
    @Input() options: {[field: string]: string};

    @Output() valueChanged: EventEmitter<string> = new EventEmitter();

    constructor() { }

    getOptionsKey() {
        return Object.keys(this.options).map(key => key);
    }

    onSelectChange(event: MatSelectChange) {
        this.valueChanged.emit(event.value);
    }

}
